<script lang="ts">
import MainStore from "@src/model/Main.Store";

export let text: string = '';


    
function handleInfoClick() {
    MainStore.setCurrentExecutingInteractionPoint(undefined);
    MainStore.getValue()._currentVideoElement?.play();
}
</script>


<div class="main-overlay-info">
    {text}

    <div>
        <button on:click={handleInfoClick}>OK</button>
    </div>
</div>


<style>
    .main-overlay-info {
        padding: 1rem;
    }
</style>
